<template>
    <div>
        <div class="font-bold text-18 text-im-black-232323">{{campaign.name}}</div>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";
import { useLocale } from "@/feature/LocaleFeature"

export default {
    setup: function() {
        const { lbl } = useLocale()

        return {
            lbl
        }
    },
    name: "DetailInfo",
    //mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    methods: {
        getPointTxt: function () {
            var pointTypeTxt = this.campaign.pointType && this.campaign.pointType != 'use'
                            ? this.lbl.detail.get_point
                            : this.lbl.detail.use_point;

            var pointUnit = this.localeCode === 1033 && this.campaign.pointPerUnit > 1
                        ? this.lbl.detail.point_unit + 's'
                        : this.lbl.detail.point_unit;

            return `${pointTypeTxt}${this.campaign.pointPerUnit} ${pointUnit}`;
        },
        agencyLogoUrl: function() {
            return ConfigManager.getBlobUrl() + "/agencies/" + this.campaign.agencyID;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
